<template>
  <div class="row-content">
    <div class="flex-box" style="width: 100%; height: 100%">
      <div class="flex-item left">
        <div class="row-title">
          <span v-if="type === 'oneYouth'">精英机构球员分布（球员总数：{{ playerNumAll }}，含2022起注册的球员）</span>
          <span v-else>
            精英机构注册球员分布（2026年各机构已注册球员共{{ playerNumAll }}人，其中男{{ playerNumAllNan }}，女{{ playerNumAllNv }}）
            </span>
        </div>
        <div class="data-wrapper">
          <div class="echart-associate-all" id="echart-associate-all"></div>
          <div style="display: flex;justify-content: flex-end;width: 100%;color:#68d8fe">注册球员数据统计时间2026年4月29日</div>
        </div>
      </div>
<!--      <div class="flex-item right">-->
<!--        <div class="line-text">-->
<!--          <span style="width: 120px">教练员总量</span>-->
<!--          <span>{{ userCount.userInfoCount }}</span>-->
<!--        </div>-->
<!--        <div class="line-text">-->
<!--          <span style="width: 120px">本月新增教练员</span>-->
<!--          <span>{{ userCount.userInfoCountMonth }}</span>-->
<!--        </div>-->
<!--        <div class="line-text">-->
<!--          <span style="width: 120px">今日新增教练员</span>-->
<!--          <span>{{ userCount.userInfoCountDay }}</span>-->
<!--        </div>-->
<!--      </div>-->
    </div>
  </div>
</template>

<script>
import echarts from "echarts";
import { debounce } from "@/assets/js/utils";

export default {
  props: {
    playerNum: {
      type: Array,
      required: true,
    },
    playerNumAll: {
      type: Number,
      required: true,
    },
    playerNumAllNan: {
      type: Number,
      required: false,
    },
    playerNumAllNv: {
      type: Number,
      required: false,
    },
    playerKey: {
      type: Array,
      required: true,
    },
    type: {
      type: String,
      required: false,
    },
//    显示球员数量的
//    userCount: {
//      type: Object,
//      required: false,
//    },
  },

  data() {
    return {
//       playerNum: [120, 200, 150, 80, 70],
//       userCount: {
//         userInfoCount: 10,
//         userInfoCountMonth: 20,
//         userInfoCountDay: 30,
//       },
    };
  },
  computed: {
    lineOptions() {
      const options = {
        color: ["#68d8fe", "#fac858", "#ee6666", "#73c0de"],
        xAxis: {
          type: "category",
          axisLabel: {
            inside: 0, // 横轴图例文字位置（true在bar上）
            rotate: 35,
            textStyle: {
              color: "#61a8ff",
            },
          },
          data: this.playerKey,
        },
        yAxis: [
          {
            type: "value",
            axisLine: {
              show: true,
              lineStyle: {
                color: "#61a8ff",
                width: 1,
                type: "solid",
              },
            },
            nameTextStyle: {
              color: ["#FFFFFF"],
            },
          },
        ],
        grid: {
          left: "12%",
          bottom: '20%'
        },
        // legend: {
        //   data: ["教练员总数量"],
        //   show: true,
        //   textStyle: {
        //     color: "#61a8ff",
        //   },
        // },
        series: [
          {
            name: "球员总数量",
            type: "bar",
            barwidth: "80%",
            data: this.playerNum,
            label: {
              show: true,
              position: "top",
              distance: 5,
              align: "center",
              verticalAlign: "middle",
            },
          },
        ],
      };
      return options;
    },
    // 查询总数
    allNumber() {
//      let allCounts = 0;
//      for (let key in this.playerNum) {
//        allCounts += this.playerNum[key]
//      }
//      return allCounts
    },
  },

  mounted() {
    const that = this;
    this.drawLine();
    if (this.lineObj) {
      window.onresize = debounce(
        function () {
          that.lineObj.resize();
        },
        100,
        false
      );
    }
  },

  methods: {
    drawLine() {
      const dom = document.getElementById("echart-associate-all");
      const lineObj = echarts.init(dom);
      this.lineObj = lineObj;
      lineObj && lineObj.setOption(this.lineOptions);
    },
  },
};
</script>

<style lang="stylus" scoped>
@import '~@/assets/css/variable'
.row-content
  height 310px !important
  padding 1.25rem 0
  .flex-box
    display flex
    width 100%
    height 100%
    .flex-item
      /* flex 1 1 */
      height 100%
      .data-wrapper
        height 100%
    .left
      flex 5
    .right
      flex 2
      padding 8rem 2rem 8rem 2rem
      display flex
      flex-direction column
      justify-content space-around
      font-size 1.4rem
      color #61a8ff
      text-align center
      .line-text
        /* text-align left */
        display flex
        justify-content space-between
        span:nth-child(1)
          display flex
          align-items center
          justify-content flex-start
        span:nth-child(2)
          font-size 2.5rem
          margin-left 5px
          color #FFFFFF
          text-align left
          display block
          width 6rem
  .echart-associate-all
    width 100%
    height 100%

.row-content
  .row-title
    color #68d8fe
    font-weight 600
    font-size 16px
    margin-bottom 0.4rem
    display flex
    align-items center
  .data-wrapper
    display flex
    flex-wrap wrap
    .echart-tutorial-add
      height 290px
      width 100%
</style>
